import {Injectable} from '@angular/core';
import {from, Observable, of} from 'rxjs';
import {concatMap, defaultIfEmpty, filter, map, take} from 'rxjs/operators';
import {FileValidationRule} from "./validation-rules/file-validation-rule";
import {FilenameValidationRule} from "./validation-rules/filenname-validation-rule";
import {FilesizeValidationRule} from "./validation-rules/filesize-validation-rule";
import {FilenameLengthValidationRule} from "./validation-rules/filename-length-validation-rule";
import {FileSignatureValidationRule} from "./validation-rules/file-signature-validation-rule";
import {ValidationResult} from "./validation-result";
import {FiletypeValidationRule} from "./validation-rules/filetype-validation-rule";

@Injectable({ providedIn: 'root' })
export class FileValidationService {
    private static readonly RULES: readonly FileValidationRule[] = [
        new FilenameValidationRule(),
        new FiletypeValidationRule(),
        new FilesizeValidationRule(),
        new FilenameLengthValidationRule(),
        new FileSignatureValidationRule()
    ];

    /**
     * Gibt ein Observable mit dem ersten Fehler oder einem valid-Result zurück.
     */
    validate(file: File): Observable<ValidationResult> {
        return from(FileValidationService.RULES).pipe(
            concatMap(rule => {
                const result = rule.validate(file);
                return (result instanceof Observable ? result : of(result))
                    .pipe(map(isValid => ({ rule, isValid })));
            }),
            // nur die, die false liefern
            filter(({ isValid }) => !isValid),
            // den ersten Fehler nehmen
            take(1),
            // in ValidationResult umwandeln
            map(({ rule }) => ({ isValid: false, messageKey: 'error.upload.validation.' + rule.errorKey})),
            // oder, wenn nie false, isValid=true
            defaultIfEmpty({ isValid: true })
        );
    }

}